const nnTranslations = {
    ok: 'Ok',
    insurance: {
        insuranceHeader: 'Forsikringane mine',
        insuranceNumberHeader: 'Viser {} av {}',
        newInsuranceHeader: 'Treng du ny forsikring?',
        newInsuranceDescription: 'Hos oss får du forsikringar tilpassa deg – og høve til å samla alt på éin stad',
        oldInsuranceDescription: 'Hos oss får du gode forsikringar tilpassa behovet ditt',
        showMore: 'Sjå forsikringane mine',
        error: 'Noko gjekk gale ved henting av forsikringane dine.',
        tryAgain: 'Prøv igjen',
        year: '/år',
        show: 'Viser',
        of: 'av',
        buyInsuranceButton: 'Kjøp forsikring',
        buyInsuranceTitle: 'Har du forsikringane du treng?',
        buyInsuranceSubtext: 'Me har gode forsikringar for dei små og store hendingane i livet. Du kan enkelt samla fleire hos oss – så får du betre oversikt og færre bekymringar.',
        seePriceAndBuyButton: 'Sjekk pris og kjøp',
        fremtindText: 'Våre forsikringar blir leverte av Fremtind',
        insurance: 'Forsikring',
    },
    holdings: {
        header: 'Sparinga mi',
        totalAmount: 'Totalt {}',
        savingHeader: 'Spara meir?',
        savingDescription: 'Du sparer i dag {} i månaden.',
        showMore: 'Sjå spareprodukta dine',
        error: 'Noko gjekk gale ved henting av spareprodukta dine.',
        tryAgain: 'Prøv igjen',
    },
    totalSavings: {
        header: 'Sparing',
        totalFundsTitle: 'Total fondssparing',
        startSavingTitle: 'Start sparing i fond',
        startSavingDescription: 'Start med eit lite beløp og bygg tryggleik over tid.',
        error: 'Me får ikkje vist spareoversikta di. Prøv igjen seinare',
        tryAgain: 'Prøv på nytt',
    },
    loans: {
        header: 'Låna mine',
        numberHeader: 'Viser {} av {}',
        infoHeader: 'Store planar?',
        infoDescription: 'Sjå kva lån me tilbyr her',
        error: 'Noko gjekk gale ved henting av låna dine.',
        tryAgain: 'Prøv igjen',
        showMore: 'Sjå låna dine',
        ekbLoans: {
            CREDIT_LOAN: 'Forbrukslån',
            EMPLOYEE: 'Forbrukslån',
            ATV: 'ATV-lån',
            CAR: 'Billån',
            CAR_NO_INSURANCE: 'Billån',
            CAR_ZERO_EMISSION: 'Elbillån',
            BOAT: 'Båtlån',
            CAMPING_CAR: 'Bobillån',
            CARAVAN: 'Campingvognlån',
            MC: 'MC-lån',
            SNOWMOBILE: 'Snøscooterlån',
        },
        moneyOnTheWay: 'Pengane er på veg',
        nominalInterest: 'Nominell rente {}%',
        studentLoan: 'Studielån',
        consentStatus: 'Ditt samtykke utløper snart',
    },
    loanOverview: {
        title: 'Andre lån',
        nominalInterest: 'Nominell rente {}%',
        studentLoan: 'Studielån',
        consentStatus: 'Ditt samtykke går snart ut',
        moneyOnTheWay: 'Pengane er på veg',
    },
    taskManager: {
        title: 'Oppgåver',
        documentsForSigning: 'Oppgåver til gjennomgang',
        emptyState: 'Her var det stille og rolig',
        noTasks: 'Du har ingen oppgåver som ventar',
        errors: {
            documents: 'Noko gjekk gale ved henting av dokumenter til signering',
            loanApplications: 'Noko gjekk gale ved henting av lånesøknadar.',
            general: 'Noko gjekk gale ved henting av oppgåver',
        },
        loanApplications: {
            type: {
                HOUSE_LOAN_INCREASE: 'Søknad om økt bustadlån',
                PROOF_OF_FINANCING: 'Søknad om finansieringsbevis',
                NEW_LOAN: 'Søknad om nytt bustadlån på eksisterande bustad',
                MOVING: 'Søknad om flytting av bustadlån',
                HOUSE_LOAN: 'Søknad om bustadlån',
                UNKNOWN: '',
            },
            status: {
                ACTIVE: 'Søknad påbyrja',
                WAITING_FOR_CO_BORROWER: 'Ventar på medlåntakar',
                APPLICATION_BEING_PROCESSED: 'Behandlast',
                APPROVED: 'Nytt lånetilbod',
                BEING_PREPARED_FOR_PAYMENT: 'Klargjerast for utbetaling',
                PAID_OUT: 'Utbetalt',
                REFUSED: 'Avslått',
                CLOSED: 'Avslutta',
                EXPIRED: 'Utløpt',
                INFORMATION_BEING_PROCESSED: 'Opplysningar blir behandla',
                WAITING_FOR_YOUR_APPROVAL: 'Ventar på ditt samtykke',
                UNKNOWN: '',
            },
            needsAction: 'Krev handling',
        },
    },
    landingPage: {
        emptyState: 'Enten er du ikkje kunde hos oss, eller så kan det vere andre årsaker til at du har landa her. Usikker?\nTa kontakt med oss!',
    },
    errorMessage: 'Orsak, det har skjedd en feil, så du kan ikkje sjekka alle låna dine.',
};
export default nnTranslations;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm5UcmFuc2xhdGlvbnMtY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL3RyYW5zbGF0aW9ucy9ublRyYW5zbGF0aW9ucy1jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxjQUFjLEdBQTJCO0lBQzNDLEVBQUUsRUFBRSxJQUFJO0lBQ1IsU0FBUyxFQUFFO1FBQ1AsZUFBZSxFQUFFLG9CQUFvQjtRQUNyQyxxQkFBcUIsRUFBRSxnQkFBZ0I7UUFDdkMsa0JBQWtCLEVBQUUseUJBQXlCO1FBQzdDLHVCQUF1QixFQUFFLGdGQUFnRjtRQUN6Ryx1QkFBdUIsRUFBRSx3REFBd0Q7UUFDakYsUUFBUSxFQUFFLHdCQUF3QjtRQUNsQyxLQUFLLEVBQUUsb0RBQW9EO1FBQzNELFFBQVEsRUFBRSxZQUFZO1FBQ3RCLElBQUksRUFBRSxLQUFLO1FBQ1gsSUFBSSxFQUFFLE9BQU87UUFDYixFQUFFLEVBQUUsSUFBSTtRQUNSLGtCQUFrQixFQUFFLGlCQUFpQjtRQUNyQyxpQkFBaUIsRUFBRSxnQ0FBZ0M7UUFDbkQsbUJBQW1CLEVBQ2YsdUpBQXVKO1FBQzNKLG9CQUFvQixFQUFFLG9CQUFvQjtRQUMxQyxZQUFZLEVBQUUsNENBQTRDO1FBQzFELFNBQVMsRUFBRSxZQUFZO0tBQzFCO0lBQ0QsUUFBUSxFQUFFO1FBQ04sTUFBTSxFQUFFLGFBQWE7UUFDckIsV0FBVyxFQUFFLFdBQVc7UUFDeEIsWUFBWSxFQUFFLGFBQWE7UUFDM0IsaUJBQWlCLEVBQUUsK0JBQStCO1FBQ2xELFFBQVEsRUFBRSx3QkFBd0I7UUFDbEMsS0FBSyxFQUFFLG9EQUFvRDtRQUMzRCxRQUFRLEVBQUUsWUFBWTtLQUN6QjtJQUNELFlBQVksRUFBRTtRQUNWLE1BQU0sRUFBRSxTQUFTO1FBQ2pCLGVBQWUsRUFBRSxvQkFBb0I7UUFDckMsZ0JBQWdCLEVBQUUsc0JBQXNCO1FBQ3hDLHNCQUFzQixFQUFFLHNEQUFzRDtRQUM5RSxLQUFLLEVBQUUseURBQXlEO1FBQ2hFLFFBQVEsRUFBRSxjQUFjO0tBQzNCO0lBQ0QsS0FBSyxFQUFFO1FBQ0gsTUFBTSxFQUFFLFdBQVc7UUFDbkIsWUFBWSxFQUFFLGdCQUFnQjtRQUM5QixVQUFVLEVBQUUsZUFBZTtRQUMzQixlQUFlLEVBQUUsMkJBQTJCO1FBQzVDLEtBQUssRUFBRSwyQ0FBMkM7UUFDbEQsUUFBUSxFQUFFLFlBQVk7UUFDdEIsUUFBUSxFQUFFLGVBQWU7UUFDekIsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLGFBQWE7WUFDMUIsUUFBUSxFQUFFLGFBQWE7WUFDdkIsR0FBRyxFQUFFLFNBQVM7WUFDZCxHQUFHLEVBQUUsUUFBUTtZQUNiLGdCQUFnQixFQUFFLFFBQVE7WUFDMUIsaUJBQWlCLEVBQUUsVUFBVTtZQUM3QixJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxVQUFVO1lBQ3ZCLE9BQU8sRUFBRSxnQkFBZ0I7WUFDekIsRUFBRSxFQUFFLFFBQVE7WUFDWixVQUFVLEVBQUUsZUFBZTtTQUM5QjtRQUNELGFBQWEsRUFBRSxtQkFBbUI7UUFDbEMsZUFBZSxFQUFFLG9CQUFvQjtRQUNyQyxXQUFXLEVBQUUsV0FBVztRQUN4QixhQUFhLEVBQUUsNkJBQTZCO0tBQy9DO0lBQ0QsWUFBWSxFQUFFO1FBQ1YsS0FBSyxFQUFFLFdBQVc7UUFDbEIsZUFBZSxFQUFFLG9CQUFvQjtRQUNyQyxXQUFXLEVBQUUsV0FBVztRQUN4QixhQUFhLEVBQUUsNEJBQTRCO1FBQzNDLGFBQWEsRUFBRSxtQkFBbUI7S0FDckM7SUFDRCxXQUFXLEVBQUU7UUFDVCxLQUFLLEVBQUUsVUFBVTtRQUNqQixtQkFBbUIsRUFBRSwwQkFBMEI7UUFDL0MsVUFBVSxFQUFFLDZCQUE2QjtRQUN6QyxPQUFPLEVBQUUsa0NBQWtDO1FBQzNDLE1BQU0sRUFBRTtZQUNKLFNBQVMsRUFBRSx5REFBeUQ7WUFDcEUsZ0JBQWdCLEVBQUUsOENBQThDO1lBQ2hFLE9BQU8sRUFBRSx5Q0FBeUM7U0FDckQ7UUFDRCxnQkFBZ0IsRUFBRTtZQUNkLElBQUksRUFBRTtnQkFDRixtQkFBbUIsRUFBRSx5QkFBeUI7Z0JBQzlDLGtCQUFrQixFQUFFLDhCQUE4QjtnQkFDbEQsUUFBUSxFQUFFLGlEQUFpRDtnQkFDM0QsTUFBTSxFQUFFLGlDQUFpQztnQkFDekMsVUFBVSxFQUFFLHFCQUFxQjtnQkFDakMsT0FBTyxFQUFFLEVBQUU7YUFDZDtZQUNELE1BQU0sRUFBRTtnQkFDSixNQUFNLEVBQUUsZ0JBQWdCO2dCQUN4Qix1QkFBdUIsRUFBRSx1QkFBdUI7Z0JBQ2hELDJCQUEyQixFQUFFLFlBQVk7Z0JBQ3pDLFFBQVEsRUFBRSxpQkFBaUI7Z0JBQzNCLDBCQUEwQixFQUFFLDRCQUE0QjtnQkFDeEQsUUFBUSxFQUFFLFVBQVU7Z0JBQ3BCLE9BQU8sRUFBRSxTQUFTO2dCQUNsQixNQUFNLEVBQUUsVUFBVTtnQkFDbEIsT0FBTyxFQUFFLFFBQVE7Z0JBQ2pCLDJCQUEyQixFQUFFLDRCQUE0QjtnQkFDekQseUJBQXlCLEVBQUUseUJBQXlCO2dCQUNwRCxPQUFPLEVBQUUsRUFBRTthQUNkO1lBQ0QsV0FBVyxFQUFFLGVBQWU7U0FDL0I7S0FDSjtJQUNELFdBQVcsRUFBRTtRQUNULFVBQVUsRUFDTiw2SEFBNkg7S0FDcEk7SUFDRCxZQUFZLEVBQUUsdUVBQXVFO0NBQ3hGLENBQUM7QUFFRixlQUFlLGNBQWMsQ0FBQyJ9